/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type DmpConnectJSAuthenticationContextAdapter from "parog-web/contexts/dmpconnect-js/authentication-context-adapter";
import type HealthCentre from "parog-web/models/health-centre";

interface Args {
  context: DmpConnectJSAuthenticationContextAdapter;
  onChange?: (string) => void;
}

export default class CnamServicesAccessFormSetPinCodeAndComputterSettingsComputerNetworkSettingsComponent extends Component<Args> {
  @tracked healthCentre: HealthCentre | undefined;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this._refreshHealthCentre();
  }

  get windowsUser(): string | undefined {
    return this.args.context.dmpConnect.windowsUserForMedic(
      this.args.context.medic
    );
  }

  set windowsUser(value: string | undefined) {
    this.args.context.dmpConnect.setWindowsUserForMedic(
      this.args.context.medic,
      value
    );
  }

  get selectedHealthCentre(): string | undefined {
    return this.args.context.dmpConnect.selectedHealthCentreForMedic(
      this.args.context.medic
    );
  }

  @action
  updateWindowsUser(event) {
    this.windowsUser = event.target.value;
  }

  @action
  setSelectedHealthCentre(value: string): void {
    this.args.context.dmpConnect.setSelectedHealthCentreForMedic(
      this.args.context.medic,
      value
    );
    this._refreshHealthCentre();
    this.args.onChange?.(value);
  }

  private _refreshHealthCentre(): void {
    this.healthCentre = this.args.context.medic.healthCentres.find(
      hc =>
        hc.finess ===
        this.args.context.dmpConnect.selectedHealthCentreForMedic(
          this.args.context.medic
        )
    );
  }
}
